import React, { createContext, useContext, useState, useEffect } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { getAppTheme } from '../theme/theme';
import { useLanguage } from './LanguageContext';

const ThemeContext = createContext(null);

export const CustomThemeProvider = ({ children }) => {
  const { dir, language } = useLanguage();
  const [mode, setMode] = useState(() => {
    const saved = localStorage.getItem('fastline_theme_mode');
    return saved ? saved : 'light';
  });

  useEffect(() => {
    localStorage.setItem('fastline_theme_mode', mode);
  }, [mode]);

  const toggleTheme = () => {
    setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
  };

  const theme = getAppTheme(mode, dir);

  return (
    <ThemeContext.Provider value={{ mode, toggleTheme, isDarkMode: mode === 'dark', language, dir }}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useAppTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useAppTheme must be used within a CustomThemeProvider');
  }
  return context;
};
